/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-24
 */

// Add third-party dependencies.
import { Container, Paper, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Add local dependencies.
import Header from '../../layout/Header';
import LoginForm from './LoginForm';

/**
 * Login page component.
 * @example
 * return <Login />
 * @returns {React.ReactElement} The login page.
 */
const Login: React.FC = () => {
  const { t } = useTranslation('auth');

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh' }}>
      <Header />
      <Container component="main" maxWidth="sm">
        <Box
          sx={{
            marginTop: 8,
            marginBottom: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Typography component="h1" variant="h4" gutterBottom>
              {t('login.pageTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {t('login.pageSubtitle')}
            </Typography>
            <LoginForm />
          </Paper>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {t('login.supportText')}{' '}
              <Link to="/contact" style={{ color: 'inherit' }}>
                {t('login.supportLink')}
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
